export default __webpack_public_path__ + "static/media/summaryImage.2a9c3c44.jpg";